import { IWidgetDefinition, IWidget, IDataResponse } from '../../common/core';
import { IFuseSearchSettings } from './fuse-search.settings';
import { SearchWidgetDefinition, SearchData } from '../search.widget/search.data';
import { ISearchState } from '../search.widget/search.settings';
import { parse, stringify } from 'numbered';

const template = require('./fuse-search.html');
const styles = require('./fuse-search.scss').toString();

export class FuseSearchData extends SearchData {
  acInputSelector = 'fuse-form';

  // TODO: remove after AAMVA cleanup
  newBoostLogic = true;

  constructor(public widget: IWidget<FuseSearchData, IFuseSearchSettings, ISearchState>) {
    super(widget);
  }

  adjustAutocompleteSettings(settings: any) {
    if (this.widget.settings.mode !== 'advanced') {
      settings.classNames = {
        // elements
        resultRowEl: '<button type="button"></button>',
        acClearEl: '<button type="button"></button>',
        queryBarSuggestionItemEl: '<button type="button"></button>',
        queryBarSuggestionsCloseEl: '<button type="button"></button>',

        searchResultsWrapperId: 'fuse-autocomplete-list',

        autocompleteWrapper: 'fssj-autocomplete-wrapper',
        searchResultsWrapper: 'fuse-autocomplete-list fuse-autocomplete-list--open',
        resultRow: 'fuse-autocomplete-list__item',
        resultRowHovered: 'fuse-autocomplete-list__item--highlighted',
        resultValueWrapper: 'fssj-result-value-wrapper',
        resultValue: 'fssj-result-value',
        resultValueIcon: 'fuse-autocomplete-list__item-icon',
        resultHighlight: 'fssj-result-highlight',
        resultGreyHighlight: 'fssj-result-greyHighlight',
        searchResults: 'fssj-searchResults',
        resultBlock: 'fssj-result-block',
      };
      settings.showIcon = true;

      settings.is_option_select_event = function (e, ac) {
        return e.keyCode == 13 && ac.btnsNavigation; // enter
      };
    }

    return super.adjustAutocompleteSettings(settings);
  }

  afterAutocompleteCreated() {
    this.$el.find('input.fuse-form__input').attr({
      "aria-autocomplete": "list"
    });
  }

  isNonSeriesRequests() {
    return super.isNonSeriesRequests() && !this.widget.s.g['enhanced_search'];
  }

  /**
   * Show suggestions only when there are no matches
   */
  setSuggestionsFromResponse(data: IDataResponse) {
    if (data.suggest && !data.series?.length) {
      super.setSuggestionsFromResponse(data);
    }
  }

  getQuery() {

    var query = super.getQuery();
    var queries = [];
    if (query) {
      queries.push(query);
    }

    var originQuery = this.widget.state.searchString;
    if (originQuery) {
      originQuery = originQuery.trim();
      if (originQuery && originQuery == query) {
        originQuery = null;
      }
    }

    if (query) {
      try {
        var qNumToWord = query.replace(/\d+/g, num => {
          return stringify(num);
        });
        var qWordToNum = query.replace(/[a-zA-Z\s]+/g, str => {
          var words = str.split(' ');
          var startIndex;
          var endIndex;
          var res;
          for (var i = words.length - 1; i >= 0; i--) {
            var w = words.slice(i, endIndex ? endIndex + 1 : i + 1).join(' ');
            var wNum = parse(w);
            if (wNum !== 0) {
              startIndex = i;
              if (endIndex === undefined) {
                endIndex = i;
              }
              res = wNum;
            } else if (startIndex !== undefined) {
              break;
            }
          }

          if (startIndex !== undefined) {
            // replace with number
            words.splice(startIndex, endIndex - startIndex + 1, res);
            return words.join(' ');
          } else {
            // nothing to replace
            return str;
          }
        });

        if (qNumToWord && qWordToNum && qNumToWord != qWordToNum) {
          queries = [
            qNumToWord,
            qWordToNum
          ];
        }
      } catch (ex) {
        console.error(ex);
        this.widget.service.captureMessage('Fuse-search: unable to convert numbered string');
      }
    }

    /*
    var boost = this.widget.settings.boostDescription;
    if (boost) {
      queries = queries.map(q => {
        if (q && q.indexOf('"') == -1) {
          return `(${q}) OR (description:"${q}")^${boost === true ? 1000 : boost}`;
        } else {
          return q;
        }
      });
    }
    */

    if (this.widget.settings.userBoost !== false) {
      var boost = this.widget.settings.userBoost || 1000;
      var capitalizeFirstLetter = (string) => {
        let words = string.split(' ');
        for (let i = 0; i < words.length; i++) {
          words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
        }
        return words.join(' ');
      }
      queries = queries.map(q => {
        if (query && query.indexOf('"') == -1) {
          return `(${query}) OR (description:"${query}")^${1000000 * boost} OR (description="${query.toLowerCase()}" or description="${query.toUpperCase()}" or description="${capitalizeFirstLetter(query)}" or description="${query}")^${10000000000000 * boost} OR ("${query}")^${10 * boost}`;
        } else {
          return q;
        }
      });

      // query could be 'clean', so also adding fallback to origin user search
      if (originQuery && originQuery.indexOf('"') == -1) {
        queries.push(`(description:"${originQuery}")^${1000000 * boost}`);
      }

    }

    if (queries.length) {
      if (queries.length == 1) {
        return queries[0];
      }
      return `(${queries.map(q => {
        return `(${q})`;
      }).join(' OR ')})`;
    }
  }

  refreshTextareaSize() {
    if (this.$textarea && this.$textarea.is('textarea')) {
      super.refreshTextareaSize();
    }
  }
}

export const FuseSearchWidgetDefinition: IWidgetDefinition<FuseSearchData, IFuseSearchSettings, ISearchState> = {
  ...SearchWidgetDefinition,
  init(widget) {
    widget.data = new FuseSearchData(widget);
  },
  template,
  styles,
};
